import { Link, useLoaderData } from 'react-router-dom';
import Seo from 'components/Seo';
import WorkPreview from 'components/WorkPreview';
import AnimationPage from 'components/AnimationPage';
import ClientsAwardsSection from 'components/ClientsAwards';
import Hero from 'components/Hero';
import "assets/styles/Home.css";
import { motion } from 'framer-motion';
import animations from 'utils/animations';

export default function Home() {
  const { opacity } = animations.components;
  const MotionLink = motion(Link);
  const home = useLoaderData();

  return (
    <AnimationPage>
      <Seo title='Kollectiff - A Creative Technology Company' />
            
      <main className="home mt-[-6.5rem]">
        <Hero /> 
        <div className='home-services container-full'>
            <div className='white-container'>    
              <div className='services-content'>

                <div className='services-title'>
                  <motion.h2
                    className="k-title-sm md:k-title-md lg:k-title-lg"
                    {...opacity}
                    transition={{ delay: 0.3 }}
                  >
                    Built for what’s next
                  </motion.h2>
                  <motion.p
                    className="k-text-md md:k-text-lg xl:k-text-xl"
                    {...opacity}
                    transition={{ delay: 0.4 }}
                  >
                    From AI-powered campaigns to immersive worlds and interactive platforms, we partner with global agencies and brands to bring ambitious ideas to life.
                  </motion.p>
                </div>
                <motion.a
                  className="btn-black"
                  {...opacity}
                  transition={{ delay: 0.5}}
                  href='/services'
                >
                  Our Services
                </motion.a>
              </div>
            </div>
        </div>

        <div className="featured-works container">
          <div className="featured-title">
            <motion.h2
              className="k-title-sm md:k-title-md lg:k-title-lg"
              {...opacity}
              transition={{ delay: 0.3 }}
            >
              Featured Works
            </motion.h2>
            <MotionLink
              className='link-sm lg:link-lg link-animated'
              to="/work"
              {...opacity}
              transition={{ delay: 0.4 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              View All Works
            </MotionLink>
          </div>

          <div className="featured-works-list">
            {home[0].works.map((work, index) => (
              <WorkPreview
                key={index}
                media={work.preview.media}
                mediaHover={work.preview.mediaHover}
                title={work.preview.title}
                description={work.preview.description}
                link={work.slug}
                tags={work.tags} />
            ))}
          </div>
        </div>
        
        <ClientsAwardsSection />


      </main>
    </AnimationPage>
  )
}
